import React from 'react'

import {
  SCROLL_POS_CONCERNS
} from '../config/constants'

class ConversationScroller extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.prevScrollTopRatio = 1

    this.listenScroll = this.listenScroll.bind(this)
  }

  componentDidMount () {
    this.refs.conversationScroller.onscroll = this.listenScroll
  }

  componentWillReceiveProps (nextProps) {
    const shouldForceUpdateScrollPos = (
      nextProps.updatingScrollConcern
      && this.props.updatingScrollConcern !== nextProps.updatingScrollConcern
      && this.state.scrollConcern !== nextProps.updatingScrollConcern
    )

    if (shouldForceUpdateScrollPos) this.scrollToConcern(nextProps.updatingScrollConcern)
  }

  componentDidUpdate () {
    if (this.props.updatingScrollConcern === SCROLL_POS_CONCERNS.BOTTOM) {
      this.maintainScrollPosition()
    }
    else if (this.props.updatingScrollConcern === SCROLL_POS_CONCERNS.HISTORY) {
      this.appendToScrollPosition()
    }
  }

  calculateRatio (scroller) {
    if (scroller.scrollHeight <= scroller.offsetHeight) {
      return scroller.scrollTop
    }
    else if (!this.isScrolledBefore) {
      return 1
    }
    else if (scroller.scrollHeight - scroller.scrollTop - scroller.offsetHeight < 1) {
      return 1
    }

    return scroller.scrollTop / (scroller.scrollHeight - scroller.offsetHeight)
  }

  notifyScrollConcernChange (ratio) {
    const {TOP, MIDDLE, BOTTOM} = SCROLL_POS_CONCERNS
    const scrollConcern = ratio === 0 ? TOP : ratio === 1 ? BOTTOM : MIDDLE

    if (scrollConcern !== this.state.scrollConcern) {
      this.props.onScrollConcernChange(scrollConcern)
      this.setState({scrollConcern})
    }
  }

  updateScrollTop (ratio, scroller) {
    scroller.scrollTop = ratio * (scroller.scrollHeight - scroller.offsetHeight)
  }

  listenScroll () {
    this.prevScrollTopRatio = this.calculateRatio(this.refs.conversationScroller)
    this.isScrolledBefore = true
    this.notifyScrollConcernChange(this.prevScrollTopRatio)
  }

  scrollToConcern (scrollConcern) {
    const {HISTORY, MIDDLE, BOTTOM, FORCE_BOTTOM} = SCROLL_POS_CONCERNS

    if (scrollConcern == FORCE_BOTTOM) this.maintainScrollPosition(true)
    if (scrollConcern === BOTTOM) this.maintainScrollPosition()
    else if (scrollConcern === MIDDLE) this.maintainScrollPosition()
    else if (scrollConcern === HISTORY) this.appendToScrollPosition()
  }

  maintainScrollPosition (isBottomForced = false) {
    if (isBottomForced || this.prevScrollTopRatio === 1) {
      this.scrollToBottom()
    }
    else {
      const cachedRatio = this.calculateRatio(this.refs.conversationScroller)
      this.updateScrollTop(cachedRatio, this.refs.conversationScroller)
    }

    this.prevScrollTopRatio = this.calculateRatio(this.refs.conversationScroller)
    this.prevHeight = this.refs.conversationScroller.scrollHeight
  }

  scrollToBottom () {
    let scroller = this.refs.conversationScroller

    this.updateScrollTop(1, scroller)
  }

  appendToScrollPosition () {
    const diff = this.refs.conversationScroller.scrollHeight - (this.prevHeight || 0)

    if (diff > 0) this.refs.conversationScroller.scrollTop += diff
    this.prevHeight = this.refs.conversationScroller.scrollHeight
  }

  render () {
    return (
      <div ref='conversationScroller' className='conversation-scroller'>
        {this.props.children}
      </div>
    )
  }
}

export default ConversationScroller



/** WEBPACK FOOTER **
 ** ./modules/shared/conversation/scroller.js
 **/